/**
 * Option lists for the game-profile wizard step + the Game-profile strip.
 *
 * - Input modalities mirror the Quarry reference's INPUT_METHODS.
 * - Genres reuse the repo's existing `GenreKey` vocabulary (genre-fallback.ts),
 *   humanised for display; the wizard pre-selects one via `inferGenreKey`.
 */
import { GENRE_KEYS, type GenreKey } from '@volley/crucible-ipc-types/genre-fallback';

/** Selectable input modalities (multi-select). Source: Quarry INPUT_METHODS. */
export const INPUT_METHODS = [
  'Voice Recognition',
  'D-Pad',
  'Drawing',
  'Gesture / Swipe',
  'Tap',
  'Typing',
  'Virtual Buttons / Stick',
  'Camera',
  'Gyroscope',
] as const;

/** Largest selectable player count for the Multiplayer mode. */
export const MAX_PLAYERS = 8;

const GENRE_LABELS: Record<GenreKey, string> = {
  trivia: 'Trivia',
  word: 'Word',
  puzzle: 'Puzzle',
  twitch: 'Twitch / Action',
  party: 'Party',
  narrative: 'Narrative',
  arcade: 'Arcade',
  music: 'Music / Rhythm',
  sport: 'Sport',
  default: 'Other',
};

export interface GenreOption {
  key: GenreKey;
  label: string;
}

/** Genre dropdown options, in the canonical `GENRE_KEYS` order. */
export const GENRE_OPTIONS: GenreOption[] = GENRE_KEYS.map((key) => ({
  key,
  label: GENRE_LABELS[key],
}));

export function genreLabel(key: GenreKey | undefined): string {
  return key ? GENRE_LABELS[key] : '';
}
